<template>
  <span>
    <form class="row px-0 mx-0">
      <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Codigo del cliente:</label>
          <input type="text" class="form-control" :value="credential.codigo" disabled />
        </div>
      </div>
     
      <div class="col-6 mb-4">
        <div class="form-group">
          <label class="mb-2 d-block">Documento:</label>
          <input type="text" class="form-control" v-model="dniNumber" :disabled="inputDisabled"/>
        
          <button style="cursor: pointer" @click.prevent="inputChangeDisabled">
            {{ inputDisabled ? "Quitar Disabled" : "Agregar Disabled" }}
          </button>

          <button
            @click.prevent="changeNumberDni"
            v-if="inputDisabled === false"
            style="cursor: pointer"
          >
            Cambiar número de DNI
          </button>
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="exampleInputEmail1" class="mb-2 d-block">E-mail de cuenta:</label>
          <input type="text" class="form-control" :value="credential.email" disabled />
          <!-- <small class="form-text text-muted">*verification purpose</small> -->
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="phone" class="mb-2 d-block">Estado de Verificado:</label>
          <input
            type="text"
            class="form-control"
            :value="credential.varificado.verified ? 'Verificado' : 'Sin verificar'"
            disabled
          />
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="phone" class="mb-2 d-block">Tipo de Registro:</label>
          <input type="text" class="form-control" :value="credential.estado" disabled />
        </div>
      </div>
      <div class="col-6 mb-2">
        <div class="form-group">
          <label for="phone" class="mb-2 d-block"
            >URL DNI anterior -> Estado - {{ credential.statuAnterior }} : (<a
              :href="credential.dniAnterior"
              target="_Blank"
              >Revisar</a
            >
            )</label
          >
          <input
            :class="[
              (credential.statuAnterior === 1 ? '' : '') ||
                (credential.statuAnterior === 2 ? 'border border-warning' : '') ||
                (credential.statuAnterior === 3 ? 'border border-success' : '') ||
                (credential.statuAnterior === 4 ? 'border border-danger' : ''),
            ]"
            type="text"
            class="form-control"
            :value="credential.dniAnterior"
            disabled
          />
          <br />
          <select
            @change="changeStatusDni(true)"
            style="margin-top: 15px"
            class="form-control"
            v-model="dni.anterior"
            name=""
            id=""
          >
            <option :value="1">1 - El usuario no subio ningún archivo</option>
            <option :value="2">2 - En espera para que el Admin verifique</option>
            <option :value="3">3 - DNI anterior verificado</option>
            <option :value="4">4 - Archivo Rechazado</option>
          </select>
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="phone" class="mb-2 d-block"
            >URL DNI posterior -> Estado - {{ credential.statuPosterior }} : (<a
              :href="credential.dniPosterior"
              target="_Blank"
              >Revisar</a
            >)
          </label>
          <input
            :class="[
              (credential.statuPosterior === 1 ? '' : '') ||
                (credential.statuPosterior === 2 ? 'border border-warning' : '') ||
                (credential.statuPosterior === 3 ? 'border border-success' : '') ||
                (credential.statuPosterior === 4 ? 'border border-danger' : ''),
            ]"
            type="text"
            class="form-control"
            :value="credential.dniPosterior"
            disabled
          />
          <select
            @change="changeStatusDni(false)"
            style="margin-top: 15px"
            class="form-control"
            v-model="dni.posterior"
            name=""
            id=""
          >
            <option :value="1">1 - El usuario no subio ningún archivo</option>
            <option :value="2">2 - En espera para que el Admin verifique</option>
            <option :value="3">3 - DNI posterior verificado</option>
            <option :value="4">4 - Archivo Rechazado</option>
          </select>
        </div>
      </div>
    </form>
  </span>
</template>
<script>
import axios from "axios";
export default {
  props: ["credential", "idUser"],
  data() {
    return {
      dni: {
        anterior: this.credential.statuAnterior,
        posterior: this.credential.statuPosterior,
      },
      inputDisabled: true,
   
      dniNumber: this.credential.documento,
    };
  },
  methods: {
    changeNumberDni() {
      let url = process.env.API_URL + "/api/admin/changeDni/" + this.idUser;
      axios
        .post(url, {
          dni: this.dniNumber,
        })
        .then(() => {
         
          location.reload();
        })
        .catch(() => {
          alert("Error al cambiar el número del DNI");

          return;
        });
    },
    inputChangeDisabled() {
      this.inputDisabled = !this.inputDisabled;
    },
    changeStatusDni(type) {
      var answer = null;
      var objDni = new Object();

      if (type === true) {
        answer = window.confirm(
          "Desea cambiar el estado del DNI anterior, al estado " + this.dni.anterior
        );
        objDni.document_state = this.dni.anterior;
        objDni.side = type;
      } else if (type === false) {
        answer = window.confirm(
          "Desea cambiar el estado del DNI posterior, al estado " + this.dni.posterior
        );
        objDni.document_state = this.dni.posterior;
        objDni.side = type;
      }

      if (answer) {
        this.is_loading = true;
        let url = process.env.API_URL + "/api/admin/changeStatusDocument/" + this.idUser;
        axios
          .post(url, objDni)
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Error al cambiar el estado del DNI");
            this.is_loading = false;
            return;
          });
      } else {
        this.dni.anterior = this.credential.statuAnterior;
        this.dni.posterior = this.credential.statuPosterior;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// CredentialComponent.vue?bf6775ec